<template>
  <div v-if="purchasePlans.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('PurchasePlans', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/purchase-plans/detail/' + purchasePlans.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("PurchasePlans.actions.detail") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("PurchasePlans.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 编辑 -->
      <v-tooltip
        top
        v-if="showEdit &&
         $permission.permissionAllow('PurchasePlans', 'edit') &&
         purchasePlans && purchasePlans.status == 1
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            :href="'/#/purchase-plans/purchase-plans-edit/' + purchasePlans.id"
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("PurchasePlans.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.editInfo", [$t("PurchasePlans.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 分配任务 -->
      <v-tooltip
        top
        v-if="showDistribute && $permission.permissionAllow('PurchasePlans', 'distribute')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('distribute')
                  : $router.push('/purchase-plans/detail/' + purchasePlans.id + '/distribute');
              })
            "
          >
            {{ $t("PurchasePlans.actions.distribute") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasePlans.actions.distribute") }}</span>
      </v-tooltip>
      <!-- 导出 -->
      <v-tooltip
        top
        v-if="
          showExport &&
          $permission.permissionAllow('PurchasePlans', 'detailExport')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="detailExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("PurchasePlans.Export.export") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasePlans.Export.export") }}</span>
      </v-tooltip>
      <!-- 作废 -->
      <v-tooltip
        top
        v-if="showCancel &&
         $permission.permissionAllow('PurchasePlans', 'cancel') &&
         purchasePlans && purchasePlans.actions.cancel
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("PurchasePlans.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasePlans.actions.cancel") }}</span>
      </v-tooltip>
    </v-sheet>
    <!-- 弹窗 -->
    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('PurchasePlans.ObjectName')"
      :code="purchasePlans.purchase_plan_code"
      @confirm="doCancel()"
    />

  </div>
</template>

<script>
import {mapState} from "vuex";
import i18n from "@/i18n";
import DialogDelete from "@/components/plugins/DialogDelete";
import PurchasePlans from "@/api/purchase_plans";

export default {
  name: "PurchasePlanDetailsActions",

  props: {
    detailMode: Boolean,
    purchasePlans: Object,
    showView: Boolean,
    showEdit: Boolean,
    showDistribute: Boolean,
    showExport: Boolean,
    showCancel: Boolean,
  },
  components: {
    DialogDelete
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    cancelAlert: false,
  }),

  methods: {
    detailExport() {
      PurchasePlans.detailExport(this.purchasePlans.id);
    },
    actionMethod(mode) {
      if (mode == "cancel") return PurchasePlans.cancel(this.purchasePlans.id);
    },
    // 操作
    doCancel() {
      this.$store.dispatch("fullscreenLoading");
      PurchasePlans.cancel(this.purchasePlans.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (this.detailMode) {
              // 返回一览页
              this.$router.push("/purchase-plans");
            }
            this.$snackbar.success(i18n.t("PurchasePlans.cancelSuccess"));
            this.$emit("done");
            this.$store.dispatch("fullscreenLoadingStop");
          }else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },
};
</script>